module.exports = __webpack_public_path__ + "static/media/Arjun.97b4018f.png";